import React from "react";
import { useCurrencyFormatter } from "../../hooks/useCurrencyFormatter";
import { MetricComponentProps } from "../../types/metrics";
import MetricItem from "./MetricItem";
import {
  formatPrincipal,
  formatInterestRate,
  formatTermLength,
} from "./metricHelpers";

export default function MonthlyPaymentSecondaryMetric({
  sim,
}: MetricComponentProps) {
  const c = useCurrencyFormatter();

  return (
    <>
      <MetricItem value={formatPrincipal(sim, c)} tooltip="Principal Amount" />
      {" • "}
      <MetricItem
        value={formatInterestRate(sim)}
        tooltip="Mortgage Interest Rate"
      />
      {" • "}
      <MetricItem value={formatTermLength(sim)} tooltip="Mortgage Term" />
    </>
  );
}
